/* eslint-disable jsx-a11y/aria-proptypes */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useRef } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelected,
  selectUploadDocId,
  uploadFile,
  downloadFile,
  createApproval,
  removeFpre,
  rejectApproval,
  selectLoading,
} from "./deliverySlice";
import { useHistory } from "react-router-dom";
import {
  formatDate,
  showSuccessDialog,
  showErrorDialog,
  StatusFormatter,
  attachFormatter,
  showDeleteDialog,
} from "../../utility";
import Select from "react-select";
import { LayoutSplashScreen } from "../../../_metronic/layout";

export const DeliveryDetail = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const didRequest = useRef(false);
  const items = useSelector(selectSelected);
  const loading = useSelector(selectLoading);
  const uploadDocId = useSelector(selectUploadDocId);
  const [tableData, setTableData] = useState([]);
  const [btnDisabled, setbtnDisabled] = useState(false);
  const [statusApproval, setStatusApproval] = useState("");
  const [idFpre, setIdFpre] = useState("");
  const [dataClient, setDataClient] = useState([]);
  const [validasiUpload, setValidasiUpload] = useState(false);

  useEffect(() => {
    const checkDataAvailable = async () => {
      try {
        if (!didRequest.current) {
          if (items.size < 1) {
            history.push("/chief-delivery");
          } else {
            const initData = items.items.map((item, index) => ({
              ...item,
              no: index + 1,
              actual_qty: item.qty,
            }));
            const data = items.items.map((e) => {
              return e.clientCode;
            });
            setTableData(initData);
            setDataClient(data);
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        // setShowSplashScreen(false);
      }

      return () => (didRequest.current = true);
    };

    if (!didRequest.current) {
      checkDataAvailable();
    } else {
      // setShowSplashScreen(false);
    }
    // eslint-disable-next-line
  }, []);

  // const testClient = ["800014", "800015"];
  const validasi = [
    "800007",
    "800016",
    "800076",
    "800077",
    "800066",
    "800008",
    "800014",
    "800127",
    "800049",
    "800052",
    "800025",
    "800023",
    "800067",
  ];

  const filterClient = dataClient.filter((d) => validasi.includes(d)); // gives ["a", "b"]

  console.log(filterClient, "filterClient");
  console.log(filterClient.length, "length");

  // Return if data null
  var retNumber;
  if (items === null) {
    history.push("/chief-delivery");
  } else {
    retNumber = items.retNumber;
  }

  useEffect(() => {
    let id;
    if (items != null) {
      id = items.fpreAttachmentId;
    }
    if (id) {
      // setDocId(id);

      const getFileSize = async () => {
        const response = await dispatch(downloadFile(retNumber));
        const size = response.payload.length / 1000;
        setDocData([
          {
            id: 1,
            docName: `FPRE-${retNumber}.pdf`,
            file: retNumber,
            size: `${size} kb`,
          },
        ]);
      };
      getFileSize();
    }
  }, [retNumber]);

  const [remark, setRemark] = useState("");
  // const [docId, setDocId] = useState(uploadDocId);
  const [docData, setDocData] = useState([]);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    const size = file.size / 1000;

    const params = {
      retNumber: retNumber,
      file: file,
    };

    try {
      const response = await dispatch(uploadFile(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.message);
        setIdFpre(response.payload.data);
        if (action.isConfirmed) {
          setDocData([
            {
              id: 1,
              // docName: file.name,
              docName: `FPRE-${retNumber}.pdf`,
              file: retNumber,
              size: `${size} kb`,
            },
          ]);
        }
      }
    } catch (error) {
      console.log(error);
      showErrorDialog("The maximum upload file is 3MB!");
    }
  };
  console.log(docData, "docData");

  const handleApprove = async () => {
    // if (filterClient.length > 0 && docData.length < 1) {
    //   return showErrorDialog(
    //     `Please Upload FPRE Client ${filterClient} Mandatory FPRE `
    //   );
    // }
    setbtnDisabled(true);
    const params = {
      retNumber: retNumber,
      payload: {
        remark: remark,
        status: "A",
      },
    };

    callApi(params);
  };

  const handleReject = async () => {
    setbtnDisabled(true);
    const params = {
      retNumber: retNumber,
      payload: {
        remark: remark,
        status: "R",
      },
    };
    try {
      const response = await dispatch(rejectApproval(params));
      setbtnDisabled(false);

      if (response.payload.status === 200) {
        history.push("/chief-delivery", true);
        const action = await showSuccessDialog(response.payload.message);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const callApi = async (params) => {
    try {
      const response = await dispatch(createApproval(params));
      console.log(response, "sad");
      // setbtnDisabled(false);

      if (response.payload.status === 200) {
        const action = await showSuccessDialog("Data has been saved!");
        if (action.isConfirmed) history.push("/chief-delivery", true);
      } else {
        setbtnDisabled(false);
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      console.log(error);
      setbtnDisabled(false);
    }
  };

  const handleDeleteFpre = async () => {
    const id = items.retNumber;

    const action = await showDeleteDialog(`Are you sure want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeFpre(id));
        if (response.payload.status === 200) {
          showSuccessDialog(response.payload.message);
        }
        setDocData([]);
      } catch (error) {
        console.log(error);
        showErrorDialog("Something went wrong!");
      }
    }
  };

  const dateFormatter = (cell) => {
    return <span>{formatDate(cell)}</span>;
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      editable: false,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Material",
      dataField: "materialCode",
      editable: false,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Material Desc",
      dataField: "materialName",
      editable: false,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Rayon Type",
      dataField: "rayonType",
      editable: false,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },

    {
      text: "Batch",
      dataField: "batch",
      editable: false,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },

    {
      text: "Uom",
      dataField: "uom",
      editable: false,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Return Uom",
      dataField: "returnUom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Nra",
      dataField: "nra",
      formatter: StatusFormatter,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Qty",
      dataField: "qty",
      editable: false,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },

    {
      text: "Client",
      dataField: "clientName",
      editable: false,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      editable: false,
      formatter: dateFormatter,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },

    {
      text: "Photo Product",
      dataField: "attachmentId",
      editable: false,
      formatter: attachFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      align: "center",
    },
    {
      text: "FSS/ASM/BM",
      dataField: "salesmanName",
      editable: false,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
  ];

  const fileFormmater = (cell, column, row) => {
    const url = `${process.env.REACT_APP_API_URL}/return/${retNumber}/fpre`;

    return (
      <span
        className={`label label-lg label-light-success label-inline cursor-pointer`}
        onClick={() => {
          window.open(url, "_blank").focus();
        }}
      >
        {cell}
      </span>
    );
  };

  const columnsDoc = [
    {
      text: "Doc Name",
      dataField: "docName",
    },
    {
      text: "File",
      dataField: "file",
      formatter: fileFormmater,
    },
    {
      text: "Size",
      dataField: "size",
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, column, formatExtraData) => {
        return (
          <div>
            <OverlayTrigger
              overlay={<Tooltip id="products-edit-tooltip">Delete</Tooltip>}
            >
              <a
                className="btn btn-icon btn-light btn-hover-danger btn-sm"
                onClick={handleDeleteFpre}
                // onClick={() => {
                //   setDocData([]);
                //   // setDocId("");
                // }}
              >
                <span className="svg-icon svg-icon-md svg-icon-danger">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                  />
                </span>
              </a>
            </OverlayTrigger>
          </div>
        );
      },
    },
  ];

  return items === null ? null : loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Chief Delivery Detail"></CardHeader>
      <CardBody>
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>APL Return Number </b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="APL Return Number "
                    disabled
                    value={items.retNumber}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Invoice Ref Number</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="number"
                    placeholder="Invoice Ref Number"
                    disabled
                    value={items.invoiceNo}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Doc Date</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Date"
                    disabled
                    value={formatDate(items.docDate)}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Reason</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Reason"
                    disabled
                    value={items.reasonName}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Customer Name</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Customer Name"
                    disabled
                    value={items.customerName}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Customer Code</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="number"
                    placeholder="Customer Code"
                    disabled
                    value={items.customerCode}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>Plant Name</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control type="text" disabled value={items.plantName} />
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>

          {/* Table Material*/}
          <BootstrapTable
            wrapperClasses="table-responsive"
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bootstrap4
            bordered={false}
            keyField="approvalDetailId"
            data={tableData}
            columns={columns}
            hover
            cellEdit={cellEditFactory({
              mode: "click",
            })}
          />
        </Form>

        <Form.Group as={Row}>
          <Form.Label column sm={2}>
            <b>Print Date</b>
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              type="text"
              disabled
              value={formatDate(items.printDate)}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row}>
          <Form.Label column sm={2}>
            <b>Handover Remarks</b>
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              as="textarea"
              style={{ height: "100px" }}
              onChange={(e) => {
                setRemark(e.target.value);
              }}
            />
          </Col>
        </Form.Group>

        {/* Table Docs Upload */}
        <Form.Group as={Row}>
          <Form.Label column sm={2}>
            <b>Upload Doc FPRE</b>
          </Form.Label>
          <Col sm={4}>
            <Form.File
              type="file"
              id="file_fpre"
              label="Input File Name"
              custom
              onChange={handleUpload}
              onClick={(e) => (e.target.value = null)}
              accept="application/pdf,image/png, image/jpg, image/jpeg"
            />
          </Col>
          <Col sm={2} className="mt-2">
            <p>
              <b className="color-red ">Max File Size 3 MB</b>
            </p>
          </Col>
          <Col sm={6} className="mt-5">
            {docData.length > 0 && (
              <BootstrapTable
                keyField="id"
                data={docData}
                columns={columnsDoc}
              />
            )}
          </Col>
        </Form.Group>
        <Form>
          <Row>
            <Col md="6" sm="6" lg="8">
              <Button
                variant="secondary"
                className="mr-5"
                onClick={() => history.push("/chief-delivery")}
              >
                Back
              </Button>
              <Button
                variant="danger"
                className="mr-5"
                disabled={btnDisabled}
                onClick={handleReject}
              >
                Reject
              </Button>
              <Button
                variant="success"
                className="mr-5"
                disabled={btnDisabled}
                onClick={handleApprove}
              >
                Approve
              </Button>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  );
};
